import React, { useState, useEffect, Fragment } from "react"
import { Button, DialogTitle, DialogContent, TextField, DialogActions, Grid, FormControl, InputLabel, MenuItem, Select, FormLabel, FormControlLabel, Radio, Dialog, Tooltip } from "@material-ui/core"
import RadioGroup from "@material-ui/core/RadioGroup"
import Autocomplete from "@material-ui/lab/Autocomplete";
import CloseIcon from "@material-ui/icons/Close"
import GetAppIcon from '@material-ui/icons/GetApp';
import AttachmentIcon from '@material-ui/icons/Attachment';
import LinkIcon from '@material-ui/icons/Link';
import { formValues, } from "../containers/ModTaskFormData"
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import moment from "moment";
import MomentUtils from "@date-io/moment";
import { backendDateFormat, dayMonthDateFormat, fieldDMYShort } from "../../../../constants";
import { addModsFormApi, deleteModsAttachment } from "../apiServices";
import { DeletePopUp } from "../../../../shared_elements";
import { regexConstants } from "../../../../constants/regEx";
import { checkApiStatus } from "../../../../utils";
import { trackActivity } from '../../../../utils/mixpanel';
import { globalPutService } from "../../../../utils/globalApiServices";
import LinkFiles from "../../../../shared_elements/components/LinkFiles";
import UploadFile from "../../../../shared_elements/components/UploadFile";
import { assetType, imgStoragePath } from "../../../../constants";
import config from "../../../../config";
import { acumenCamo } from "../../../../shared_elements/components";

const ModsTaskForm = (props) => {
	const {
		formTitle, closeAddForm, editFormId, editFormData,
		attachments: propAttachments, updateFormData, fileUploadData,
		uuid, last_used_folder_uuid, last_used_folder_uuid_link_document,
		checkbox_last_used_folder_uuid, checkbox_last_used_folder_name,
		getResponseBack, actionType
	} = props;

	const [error, setError] = useState({});
	const [data, setData] = useState(formValues);
	const [attachments, setAttachments] = useState([]);
	const [newUploadedAttachments, setNewUploadedAttachments] = useState([]);
	const [open, setOpen] = useState(false);
	const [deleteAttachmentId, setDeleteAttachmentId] = useState(0);
	const [linkFile, setLinkFile] = useState(false);
	const [uploadFile, setUploadFile] = useState(false);

	useEffect(() => {
		if (editFormId) fillEditData();
		trackActivity('CAMO', {
			event_type: 'Modal Opened',
			page_title: 'Mods Add Task Form',
		});
	}, []);

	const fillEditData = () => {
		setAttachments(propAttachments || []);
		setData(editFormId ? editFormData : {});
	};

	const onFieldChange = (keyParam, value) => {
		setData(prev => ({ ...prev, [keyParam]: value }));
	};

	const onRestErrorKey = (keyParam) => {
		setError(prev => ({ ...prev, [keyParam]: "" }));
	};

	const buildValidationInputs = (formData) => ({
		ata_chapter: (acumenCamo || formData?.ata_chapter?.trim()) ? '' : "Please enter ATA chapter",
		mod_ref_number: formData?.mod_ref_number?.trim() ? '' : "Please enter ATA chapter",
	});

	const handleSubmit = async (e, currentBtnStatus = "add") => {
		e.preventDefault();
		const validationInputs = buildValidationInputs(data);
		if (Object.values(validationInputs).every(v => v === "")) {
			const modsProps = props.props;
			let payload = Object.assign({}, data)
			delete payload.ad_due
			delete payload.remaining_val
			payload = {
				...payload,
				last_done_fc: payload.last_done_fc || null,
				last_done_fh: payload.last_done_fh || null,
				mod_compliance_tsn: payload.last_done_fc || null,
				mod_compliance_csn: payload.last_done_fc || null,
			}
			if (actionType === "add") {
				payload.asset_id = modsProps.match.params.asset
				payload.asset_type_id = modsProps.match.params.assetType
			}
			if (actionType === "add") {
				addModsFormApi(payload, modsProps).then(async (response) => {
					const uploadId = response.data.data.id;
					if (uploadId) {
						await uploadFileTest(uploadId, modsProps, false, currentBtnStatus);
						trackActivity('CAMO', {
							event_type: 'Task Added Successfully',
							page_title: 'Mods',
							item_id: uploadId || '',
							request_body: payload || '',
							response_msg: response.data.message || ''
						});
					}
				});
				if (currentBtnStatus !== "addAnother") {
					closeAddForm();
				}
			} else {
				if (editFormId) {
					await uploadFileTest(editFormId, modsProps, true, "update");
				}
				await updateFormData(editFormId, payload, modsProps);
				closeAddForm();
				trackActivity('CAMO', {
					event_type: 'Task Updated Successfully',
					page_title: 'Mods',
					item_id: editFormId || '',
					request_body: payload || ''
				});
			}
		} else {
			setError(validationInputs);
			trackActivity('CAMO', {
				event_type: actionType === "add" ? 'Add TASK Failed' : 'Update TASK Failed',
				page_title: 'Mods',
				error_source: 'Frontend',
				error_type: validationInputs || ''
			});
		}
	};

	const saveAndAddAnother = (e) => handleSubmit(e, "addAnother");

	const uploadFileTest = async (uploadId, modsProps, isUpdate, currentBtnStatus) => {
		if (newUploadedAttachments.length > 0) {
			const formdata = new FormData();
			const module_type_id = 6;
			Object.keys(newUploadedAttachments).forEach((key) => {
				formdata.append(`[${key}]file`, newUploadedAttachments[key]);
				formdata.append(`[${key}]file_type`, newUploadedAttachments[key].type);
				formdata.append(`[${key}]file_name`, newUploadedAttachments[key].name);
				formdata.append(`[${key}]module_id`, uploadId);
				formdata.append(`[${key}]module_type_id`, module_type_id);
				formdata.append(`[${key}]asset_id`, modsProps.match.params.asset);
				formdata.append(`[${key}]asset_type_id`, modsProps.match.params.assetType);
			});
			fileUploadData(uploadId, formdata, modsProps, true);
			if (currentBtnStatus === "addAnother") {
				resetBothAttachmentArray();
			}
			if (!isUpdate) {
				onSubmitFileLink(uploadId);
				fileUploadData(uploadId, null, modsProps, false);
			}
		} else {
			if (currentBtnStatus === "addAnother") {
				setData(formValues);
				setAttachments([]);
				setNewUploadedAttachments([]);
				setOpen(false);
				setDeleteAttachmentId(0);
				document.getElementById("asset-form").reset();
				fileUploadData(uploadId, null, modsProps, false);
			} else if (!isUpdate) {
				onSubmitFileLink(uploadId);
				fileUploadData(uploadId, null, modsProps, false);
			}
		}
	};

	const resetBothAttachmentArray = () => {
		setData(formValues);
		setAttachments([]);
		setNewUploadedAttachments([]);
		setOpen(false);
		setDeleteAttachmentId(0);
		document.getElementById("asset-form").reset();
	};

	const onUpload = (files) => {
		const chosenFiles = Array.prototype.slice.call(files);
		for (let i = 0; i < chosenFiles.length; i++) {
			if (chosenFiles[i].size > 52428800) {
				props.props.enqueueSnackbar(
					`${chosenFiles[i].name} Maximum file size should be 50MB.`,
					{ variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } }
				);
				delete chosenFiles[i];
			} else {
				handleUploadFiles(chosenFiles);
			}
		}
	};

	const handleUploadFiles = (files) => {
		const uploaded = [...newUploadedAttachments];
		const existingAttachments = [...attachments];
		files.forEach((file) => {
			uploaded.push(file);
			existingAttachments.push({
				id: 0,
				module_id: 2,
				module_type_id: 6,
				file_name: file.name,
				file_type: file.type,
				file: "",
				name: file.name,
			});
		});
		setNewUploadedAttachments(uploaded);
		setAttachments(existingAttachments);
	};

	const handleCloseAttachment = () => {
		setOpen(false);
		setDeleteAttachmentId(0);
	};

	const deleteAttachmentFile = async (id, file) => {
		if (id !== undefined && id !== 0) {
			deleteModsAttachment(id, props.props);
			setAttachments(prev => prev.filter(att => att.id !== id));
			setOpen(false);
			setDeleteAttachmentId(0);
		} else {
			onRemoveCamoFile(file);
		}
	};

	const getResponseBackFn = (file) => {
		setData(prev => ({ ...prev, checklist: file }));
	};

	const listResponseBack = (file) => {
		if (actionType !== "add") {
			getResponseBack(file);
		}
	};

	const onUnlinkCheckListFile = (checklist, fileId) => {
		let payload = {};
		payload.delete = true;
		payload.folder_ids = checklist?.folders?.filter(items => items.type === 'folder').map(file => file.id).filter(id => id !== fileId).join(',');
		payload.file_ids = checklist?.files?.filter(items => items.type === 'file').map(file => file.id).filter(id => id !== fileId).join(',');
		globalPutService(`camo/ht/${editFormId}/document-checklists/`, payload)
			.then((response) => {
				if (checkApiStatus(response)) {
					const updatedChecklist = { ...checklist };
					updatedChecklist.files = updatedChecklist.files.filter(file => file.id !== fileId);
					updatedChecklist.folders = updatedChecklist?.folders.filter(file => file.id !== fileId);
					setData(prev => ({ ...prev, checklist: updatedChecklist }));
				}
				trackActivity('CAMO', {
					event_type: 'Checklist File Unlinked',
					page_title: 'Mods',
					file_id: fileId || '',
					edited_form_id: editFormId || '',
					request_body: payload || ''
				});
			});
	};

	const onRemoveFile = (file) => {
		setData(prev => ({ ...prev, checklist: prev.checklist.filter(item => item.name !== file.name) }));
	};

	const onRemoveCamoFile = (file) => {
		setAttachments(prev => prev.filter(item => item.file_name !== file.file_name));
	};

	const onLinkFile = (file, linkUuid, type) => {
		if (type === "link" || linkUuid) {
			const folderUUID = [...(data.folder_uuid || []), linkUuid];
			const updatedChecklist = [...(data.checklist || []), file];
			setData(prev => ({
				...prev,
				checklist: updatedChecklist.flat(),
				folder_uuid: folderUUID.flat(),
			}));
		} else {
			onUpload(file);
		}
	};

	const onSubmitFileLink = (id) => {
		if (data?.checklist?.length > 0 && data.checklist.map(item => item.id).filter(item => item)) {
			let payload = {};
			if (data.checklist.some(item => item.type === 'folder') && data.checklist.some(item => item.type === 'file')) {
				payload.folder_ids = data.checklist.filter(item => item.type === 'folder').map(file => file.id).join(',');
				payload.file_ids = data.checklist.filter(item => item.type === 'file').map(file => file.id).join(',');
			} else if (data.checklist.some(item => item.type === 'folder')) {
				payload.folder_ids = data.checklist.filter(item => item.type === 'folder').map(file => file.id).join(',');
			} else {
				payload.file_ids = data.checklist.filter(item => item.type === 'file').map(file => file.id).join(',');
			}
			globalPutService(`camo/mods/${id}/document-checklists/`, payload).then(response => {
				if (checkApiStatus(response)) {
					getResponseBack();
				} else {
					props.props.enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
				}
			});
		}
		if (data?.folder_uuid?.length > 0 && data.folder_uuid.filter(item => item !== undefined)) {
			const formData = new FormData();
			formData.append('folder_uuid', data.folder_uuid.filter(item => item !== undefined));
			data.checklist.filter(item => item instanceof File).forEach((file) => {
				formData.append('files[]', file);
			});
			globalPutService(`camo/mods/${id}/document-checklists/`, formData).then(response => {
				if (checkApiStatus(response)) {
					getResponseBack();
				} else {
					props.props.enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
				}
			});
		}
	};

	const modsIsValidNum = (val) => val !== null && val !== undefined && val !== '' && !isNaN(Number(val))
	const modsIsValidDate = (date) => !!date && moment(date).isValid()
	const modsSafeDecimal = (val) => {
		const n = Number(val)
		if (isNaN(n)) return null
		return Number.isInteger(n) ? n : parseFloat(n.toFixed(2))
	}

	const modsNextDueValue = () => {
		if (data.mod_interval_type === "FH") {
			if (!modsIsValidNum(data.last_done_fh) || !modsIsValidNum(data.mod_interval)) return ""
			return modsSafeDecimal(+data.last_done_fh + +data.mod_interval) ?? ""
		} else if (data.mod_interval_type === "FC") {
			if (!modsIsValidNum(data.last_done_fc) || !modsIsValidNum(data.mod_interval)) return ""
			return modsSafeDecimal(+data.last_done_fc + +data.mod_interval) ?? ""
		} else if (data.mod_interval_type === "D") {
			if (!modsIsValidDate(data.last_done_date) || !modsIsValidNum(data.mod_interval)) return ""
			return moment(data.last_done_date).add(+data.mod_interval, "days").format("DD-MM-YYYY")
		}
		return ""
	}

	const modsRemainingVal = () => {
		if (data.mod_interval_type === "FH") {
			if (!modsIsValidNum(data.last_done_fh) || !modsIsValidNum(data.mod_interval) || !modsIsValidNum(props.headerTsn)) return ""
			return modsSafeDecimal((+data.last_done_fh + +data.mod_interval) - +props.headerTsn) ?? ""
		} else if (data.mod_interval_type === "FC") {
			if (!modsIsValidNum(data.last_done_fc) || !modsIsValidNum(data.mod_interval) || !modsIsValidNum(props.headerCsn)) return ""
			return modsSafeDecimal((+data.last_done_fc + +data.mod_interval) - +props.headerCsn) ?? ""
		} else if (data.mod_interval_type === "D") {
			if (!modsIsValidDate(data.last_done_date) || !modsIsValidNum(data.mod_interval)) return ""
			return +data.mod_interval - moment().diff(moment(data.last_done_date), "days")
		}
		return ""
	}

	const modTypeOptions = [
		{ label: "STC", value: "STC" },
		{ label: "Local Modification", value: "LOCALMODIFICATION" },
		{ label: "Others", value: "OTHERS" }
	];
	const complianceOptions = [
		{ label: "OPEN", value: "OPEN" },
		{ label: "COMPLIED", value: "COMPLIED" },
		{ label: "PARTIALLY COMPLIED", value: "PARTIALLY COMPLIED" },
		{ label: "CLOSED", value: "CLOSED" },
		{ label: "NOT APPLICABLE", value: "NOT APPLICABLE" }
	];

	return (
		<Fragment>
			<div id="AmpTaskForm">
				<div className="mods" id="HtTaskForm">
					<DialogTitle>
						{formTitle}
						<CloseIcon
							onClick={() => { closeAddForm(); listResponseBack(); }}
							className="close-icon"
						/>
					</DialogTitle>
					<form
						id="asset-form"
						onSubmit={handleSubmit}
					>
						<DialogContent>
							<Grid spacing={1} container>
								<Grid item md={3} sm={6} xs={12}>
									<TextField
										required={acumenCamo ? false : true}
										variant="outlined"
										label="ATA Chapter"
										name="ata_chapter"
										id="ata_chapter"
										value={data?.ata_chapter || ''}
										error={acumenCamo ? false : !!error.ata_chapter}
										helperText={acumenCamo ? "" : error.ata_chapter || ""}
										onChange={(e) => onFieldChange("ata_chapter", e.target.value)}
										inputProps={{ maxLength: 15 }}
										onFocus={() => onRestErrorKey("ata_chapter")}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<TextField
										required={true}
										variant="outlined"
										label="MOD Reference Number"
										name="mod_ref_number"
										id="mod_ref_number"
										value={data?.mod_ref_number || ''}
										error={!!error.mod_ref_number}
										helperText={error.mod_ref_number || ""}
										inputProps={{ maxLength: 25 }}
										onChange={(e) => onFieldChange("mod_ref_number", e.target.value)}
										onFocus={() => onRestErrorKey("mod_ref_number")}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<TextField
										variant="outlined"
										label="MOD Issued by"
										name="mod_issued_by"
										id="mod_issued_by"
										value={data?.mod_issued_by || ''}
										inputProps={{ maxLength: 20 }}
										onChange={(e) => onFieldChange("mod_issued_by", e.target.value)}
										onFocus={() => onRestErrorKey("mod_issued_by")}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<TextField
										variant="outlined"
										label="MOD Applicability"
										name="mod_applicability"
										id="mod_applicability"
										value={data?.mod_applicability || ''}
										inputProps={{ maxLength: 20 }}
										onChange={(e) => onFieldChange("mod_applicability", e.target.value)}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item md={12} sm={12} xs={12}>
									<TextField
										variant="outlined"
										label="MOD Description"
										name="description"
										id="description"
										multiline
										value={data?.description || ''}
										onChange={(e) => onFieldChange("description", e.target.value)}
										onFocus={() => onRestErrorKey("description")}
										InputLabelProps={{ shrink: true }}
										inputProps={{ maxLength: 250 }}
									/>
								</Grid>

								<Grid item md={3} sm={6} xs={12} id="ht-dropdown">
									<Autocomplete
										name="type"
										id="type"
										options={modTypeOptions || []}
										getOptionLabel={(option) => option.label || ""}
										value={modTypeOptions.find((opt) => opt.value === data?.type) || null}
										onChange={(e, newValue) => onFieldChange("type", newValue ? newValue?.value : null)}
										renderInput={(params) => (
											<TextField
												{...params}
												label="MOD Type"
												variant="outlined"
												InputLabelProps={{ shrink: true }}
											/>
										)} />
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<TextField
										variant="outlined"
										label="MOD Effectivity"
										name="effectivity"
										id="effectivity"
										value={data?.effectivity || ''}
										inputProps={{ maxLength: 25 }}
										onChange={(e) => onFieldChange("effectivity", e.target.value)}
										onFocus={() => onRestErrorKey("effectivity")}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12} className="input-calender">
									<MuiPickersUtilsProvider utils={MomentUtils}>
										<KeyboardDatePicker
											id="effectivity_date"
											label="MOD Effective Date"
											format={acumenCamo ? fieldDMYShort : dayMonthDateFormat}
											inputVariant="outlined"
											fullWidth
											disableFuture
											InputLabelProps={{ shrink: true }}
											minDate={moment().subtract(25, "years")}
											value={data.effectivity_date}
											error={!!error.effectivity_date}
											helperText={error.effectivity_date || ""}
											onChange={(val) => {
												onFieldChange("effectivity_date", moment(val).format(backendDateFormat));
												onRestErrorKey("effectivity_date");
											}}
										/>
									</MuiPickersUtilsProvider>
								</Grid>
								<Grid item md={3} sm={6} xs={12} className="input-calender">
									<MuiPickersUtilsProvider utils={MomentUtils}>
										<KeyboardDatePicker
											id="last_done_date"
											label="Last Done Date"
											format={acumenCamo ? fieldDMYShort : dayMonthDateFormat}
											inputVariant="outlined"
											fullWidth
											disableFuture
											InputLabelProps={{ shrink: true }}
											minDate={moment().subtract(25, "years")}
											value={data.last_done_date}
											error={!!error.last_done_date}
											helperText={error.last_done_date || ""}
											onChange={(val) => {
												onFieldChange("last_done_date", moment(val).format(backendDateFormat));
												onRestErrorKey("last_done_date");
											}}
										/>
									</MuiPickersUtilsProvider>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<TextField
										variant="outlined"
										label="Last Done FH"
										name="last_done_fh"
										id="last_done_fh"
										value={data?.last_done_fh || ''}
										onChange={(e) => onFieldChange("last_done_fh", e.target.value)}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<TextField
										variant="outlined"
										label="Last Done FC"
										name="last_done_fc"
										id="last_done_fc"
										value={data?.last_done_fc || ''}
										onChange={(e) => onFieldChange("last_done_fc", e.target.value)}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<TextField
										variant="outlined"
										label="MOD Compliance TSN"
										name="mod_compliance_tsn"
										id="mod_compliance_tsn"
										value={data?.mod_compliance_tsn || ''}
										inputProps={{ maxLength: 10 }}
										onChange={(e) => onFieldChange("mod_compliance_tsn", e.target.value)}
										onFocus={() => onRestErrorKey("mod_compliance_tsn")}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<TextField
										variant="outlined"
										label="MOD Compliance CSN"
										name="mod_compliance_csn"
										id="mod_compliance_csn"
										value={data?.mod_compliance_csn || ""}
										onChange={(e) =>
											regexConstants.onlyNumeric.test(e.target.value)
												? onFieldChange("mod_compliance_csn", e.target.value)
												: e.preventDefault()
										}
										onFocus={() => onRestErrorKey("mod_compliance_csn")}
										InputLabelProps={{ shrink: true }}
										inputProps={{ maxLength: 10 }}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12} className="input-calender">
									<MuiPickersUtilsProvider utils={MomentUtils}>
										<KeyboardDatePicker
											id="mod_compliance_date"
											label="MOD Compliance Date"
											format={acumenCamo ? fieldDMYShort : dayMonthDateFormat}
											inputVariant="outlined"
											disableFuture
											InputLabelProps={{ shrink: true }}
											minDate={moment().subtract(25, "years")}
											value={data.mod_compliance_date}
											error={!!error.mod_compliance_date}
											helperText={error.mod_compliance_date || ""}
											onChange={(val) => {
												onFieldChange("mod_compliance_date", moment(val).format(backendDateFormat));
												onRestErrorKey("mod_compliance_date");
											}}
										/>
									</MuiPickersUtilsProvider>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<TextField
										variant="outlined"
										label="Document Number"
										name="document_number"
										id="document_number"
										value={data.document_number}
										inputProps={{ maxLength: 25 }}
										onChange={(e) => onFieldChange("document_number", e.target.value)}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<TextField
										variant="outlined"
										label="Workorder"
										name="workorder"
										id="workorder"
										inputProps={{ maxLength: 25 }}
										value={data?.workorder || ''}
										onChange={(e) => onFieldChange("workorder", e.target.value)}
										InputLabelProps={{ shrink: true }}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12}>
									<Autocomplete
										options={complianceOptions || []}
										getOptionLabel={(option) => option.label || ""}
										value={complianceOptions.find((opt) => opt.value === data?.mod_compliance_status) || null}
										onChange={(e, newValue) => onFieldChange("mod_compliance_status", newValue ? newValue?.value : null)}
										renderInput={(params) => (
											<TextField
												{...params}
												label="MOD Compliance Status"
												variant="outlined"
												name="mod_compliance_status"
												id="mod_compliance_status"
												InputLabelProps={{ shrink: true }}
											/>
										)} />
								</Grid>
							</Grid>
							<div className="border-grey"></div>
							<Grid spacing={1} id="data-container" container>
								<Grid item md={3} sm={6} xs={12} id="ht-dropdown" className="mod-period">
									<label className="ml-10px font-14">INTERVAL</label>
									<FormControl>
										<InputLabel id="demo-simple-select-label" className="dropdown-label">
											MOD Compliance Period
										</InputLabel>
										<Select
											labelId="mod_interval_type"
											name="mod_interval_type"
											id="mod_interval_type"
											error={!!error.mod_interval_type}
											variant="outlined"
											value={data.mod_interval_type}
											onChange={(e) => onFieldChange("mod_interval_type", e.target.value)}
										>
											<MenuItem value={"D"}>Days</MenuItem>
											<MenuItem value={"FH"}>FH</MenuItem>
											<MenuItem value={"FC"}>FC</MenuItem>
										</Select>
									</FormControl>
								</Grid>
								<Grid item md={3} sm={6} xs={12} id="dimensions-input">
									<label style={{ marginTop: '11px' }}></label>
									<TextField
										variant="outlined"
										label="MOD Compliance"
										name="mod_interval"
										id="mod_interval"
										value={data?.mod_interval || ''}
										InputLabelProps={{ shrink: true }}
										onChange={(e) => onFieldChange("mod_interval", e.target.value)}
									/>
								</Grid>
								<Grid item md={3} sm={6} xs={12} id="custom-padding">
									<label className="ml-10px font-14">NEXT DUE </label>
									<Grid spacing={2} container>
										<Grid className="remaining-input" item xs={6}>
											<TextField
												variant="outlined"
												label={data.mod_interval_type === "FH" ? "FH" : data.mod_interval_type === "FC" ? "FC" : "Days"}
												name="ad_due"
												id="ad_due"
												value={modsNextDueValue() ?? ''}
												inputProps={{ readOnly: true }}
												disabled
												className="disabled-input"
												InputLabelProps={{ shrink: true }}
											/>
										</Grid>
									</Grid>
								</Grid>
								<Grid item md={3} sm={6} xs={12} id="custom-padding">
									<label className="ml-10px font-14">REMAINING</label>
									<Grid spacing={1} container>
										<Grid className="remaining-input" item xs={6}>
											<TextField
												variant="outlined"
												label={data.mod_interval_type === "FH" ? "FH" : data.mod_interval_type === "FC" ? "FC" : "Days"}
												name="remaining_val"
												id="remaining_val"
												value={modsRemainingVal() ?? ''}
												inputProps={{ readOnly: true }}
												disabled
												className="disabled-input"
												InputLabelProps={{ shrink: true }}
											/>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
							<Grid id="data-container" spacing={1} container>
								<Grid item md={4} sm={6} xs={12}>
									<label>MOD Compliance DFP</label>
									<FormControl onFocus={() => onRestErrorKey("mod_compliance_dfp")}>
										<RadioGroup
											required
											row
											aria-label="mod_compliance_dfp"
											name="mod_compliance_dfp"
											defaultValue="top"
											value={data.mod_compliance_dfp}
											onChange={(e) => onFieldChange("mod_compliance_dfp", e.target.value)}
										>
											<FormControlLabel value="yes" control={<Radio size="small" color="primary" />} label="Yes" />
											<FormControlLabel value="no" control={<Radio size="small" color="primary" />} label="No" />
										</RadioGroup>
										{error.mod_compliance_dfp && (
											<FormLabel component="mod_compliance_dfp">
												<span style={{ color: "red" }}> {error.mod_compliance_dfp} </span>
											</FormLabel>
										)}
									</FormControl>
								</Grid>
								<Grid item md={4} sm={6} xs={12}>
									<label>Release Certificate </label>
									<FormControl component="fieldset">
										<FormLabel component="legend"></FormLabel>
										<RadioGroup
											row
											aria-label="release_certificate"
											name="release_certificate"
											defaultValue="top"
											value={data.release_certificate}
											onChange={(e) => onFieldChange("release_certificate", e.target.value)}
										>
											<FormControlLabel value="yes" control={<Radio size="small" color="primary" />} label="Yes" />
											<FormControlLabel value="no" control={<Radio size="small" color="primary" />} label="No" />
										</RadioGroup>
									</FormControl>
								</Grid>
								<Grid item md={4} sm={6} xs={12}>
									<label>Certificate of Conformity</label>
									<FormControl component="fieldset">
										<FormLabel component="legend"></FormLabel>
										<RadioGroup
											row
											aria-label="certificate_of_conformity"
											name="certificate_of_conformity"
											defaultValue="top"
											value={data.certificate_of_conformity}
											onChange={(e) => onFieldChange("certificate_of_conformity", e.target.value)}
										>
											<FormControlLabel value="yes" control={<Radio size="small" color="primary" />} label="Yes" />
											<FormControlLabel value="no" control={<Radio size="small" color="primary" />} label="No" />
											<FormControlLabel value="N/A" control={<Radio size="small" color="primary" />} label="N/A" />
										</RadioGroup>
									</FormControl>
								</Grid>
							</Grid>
							<Grid spacing={1} container>
								<Grid item md={6} sm={12} xs={12}>
									<TextField
										label="Remarks"
										margin='normal'
										variant='outlined'
										fullWidth
										value={data?.remark || ''}
										InputLabelProps={{ shrink: true }}
										onChange={(e) => onFieldChange("remark", e.target.value)}
										rows={3}
										multiline
										inputProps={{ maxLength: 250 }}
									/>
								</Grid>
								<Grid item md={6} sm={12} xs={12}>
									<div className="upload-amp-textbox" style={{ border: "1px solid gray", textAlign: 'center' }}>
										<ul className="list-inline spacing-list">
											<li className="list-inline-item" onClick={() => setUploadFile(true)}>
												<span className="flex-centered"><AttachmentIcon color='primary' fontSize='small' /> Upload File</span>
											</li>
											<li className="list-inline-item" onClick={() => setLinkFile(true)}>
												<span className="flex-centered"><LinkIcon color='primary' fontSize='small' />Link file from Records Module</span>
											</li>
										</ul>
									</div>
								</Grid>
							</Grid>
							<Grid id="data-container" spacing={1} container>
								<Grid spacing={1} container>
									{actionType === 'add' ?
										<div className='checklist-files'>
											<ul className='list-inline'>
												{data?.checklist?.map((file, idx) =>
													<li key={idx} className='list-inline-item'>
														<span className='file-name'>{file.name}</span>
														<span className='file-remove'>
															<a href={decodeURIComponent(file.path)} download={file.name}><GetAppIcon color="primary" /></a>
															<CloseIcon onClick={() => onRemoveFile(file)} color='secondary' fontSize='small' />
														</span>
													</li>
												)}
												{attachments?.map((attachment, idx) =>
													<li key={idx} className='list-inline-item'>
														<span className='file-name'>{attachment.file_name}</span>
														<span className='file-remove'>
															<a href={decodeURIComponent(attachment.file)} download={attachment.file_name}><GetAppIcon color="primary" /></a>
															<CloseIcon onClick={() => onRemoveCamoFile(attachment)} color='secondary' fontSize='small' />
														</span>
													</li>
												)}
											</ul>
										</div>
										:
										<div className='checklist-files'>
											<ul className='list-inline'>
												{data?.checklist?.files?.map((file, idx) =>
													<li key={idx} className='list-inline-item'>
														<span className='file-name'>{file.name}</span>
														<span className='file-remove'>
															<a href={decodeURIComponent(file.path)} download={file.name}><GetAppIcon color="primary" /></a>
															<CloseIcon onClick={() => onUnlinkCheckListFile(data.checklist, file.id)} color='secondary' fontSize='small' />
														</span>
													</li>
												)}
												{data.checklist?.folders?.length > 0 && data.checklist.folders.map((file) => (
													<li className='list-inline-item' key={file.id}>
														<Tooltip title={`Records Data Room :- ${file?.location}`} arrow>
															<a href={`${config.domain.records}${assetType[props.props?.match.params.assetType]}/${file?.asset_slug}/data-room/technical/${file?.uuid}`} target="_new">
																<img style={{ width: '15px', float: 'right', marginRight: '-18px', marginTop: '7px' }} src={imgStoragePath + 'phase-2/RecordsIcon.svg'} alt="Records Data Room" />
															</a>
														</Tooltip>
														<span className='file-name'>{file.name}</span>
														<span className='file-remove'>
															<CloseIcon onClick={() => onUnlinkCheckListFile(data.checklist, file.id)} color='secondary' fontSize='small' />
														</span>
													</li>
												))}
												{attachments?.map((attachment, idx) =>
													<li key={idx} className='list-inline-item'>
														<span className='file-name'>{attachment.file_name}</span>
														<span className='file-remove'>
															<a href={decodeURIComponent(attachment.file)} download={attachment.file_name}><GetAppIcon color="primary" /></a>
															<CloseIcon onClick={() => deleteAttachmentFile(attachment.id, attachment)} color='secondary' fontSize='small' />
														</span>
													</li>
												)}
											</ul>
										</div>
									}
								</Grid>
							</Grid>
						</DialogContent>
						<DialogActions className="actions-btn">
							<Button
								type="button"
								className="btn btn-primary"
								onClick={handleSubmit}
							>
								{actionType === "add" ? "Add" : "Update"}
							</Button>
							{actionType === "add" && (
								<Button onClick={saveAndAddAnother} type="button" className="btn btn-primary">
									Save & Add Another
								</Button>
							)}
							<Button type="button" className="btn btn-primary" onClick={() => { closeAddForm(); listResponseBack(); }}>
								Close
							</Button>
						</DialogActions>
						{open ? (
							<DeletePopUp
								title="Delete Attachment"
								deleteRecordFn={() => deleteAttachmentFile(deleteAttachmentId)}
								modal={true}
								content="Do you really want to delete the selected Attachment?"
								toggleModalFn={handleCloseAttachment}
								confirmText="Confirm"
								cancelText="Cancel"
							/>
						) : null}
						<Dialog open={linkFile} onClose={() => setLinkFile(false)} id="htDialog">
							<LinkFiles
								handleClose={() => setLinkFile(false)}
								uuid={uuid?.uuid}
								editFormId={editFormId}
								getResponseBack={(file) => getResponseBackFn(file)}
								listResponseBack={(file) => listResponseBack(file)}
								actionType={actionType}
								onLinkFile={(file, any, type) => onLinkFile(file, any, type)}
								modType="mods"
								last_used_folder_uuid={last_used_folder_uuid_link_document}
								uploadFileInfo={data}
								attachments={attachments}
								type="link"
							/>
						</Dialog>
						<Dialog open={uploadFile} onClose={() => setUploadFile(false)} id="htDialog">
							<UploadFile
								handleClose={() => setUploadFile(false)}
								uuid={uuid?.uuid}
								editFormId={editFormId}
								getResponseBack={(file) => getResponseBackFn(file)}
								listResponseBack={(file) => listResponseBack(file)}
								actionType={actionType}
								onLinkFile={(file, linkUuid) => onLinkFile(file, linkUuid)}
								modType="mods"
								uploadFileInfo={data}
								last_used_folder_uuid={last_used_folder_uuid}
								onUpload={(file) => onUpload(file)}
								type="upload"
								checkbox_last_used_folder_uuid={checkbox_last_used_folder_uuid}
								checkbox_last_used_folder_name={checkbox_last_used_folder_name}
							/>
						</Dialog>
					</form>
				</div>
			</div>
		</Fragment>
	);
};

export default ModsTaskForm;
